import * as React from 'react';
import Button from '../button';
import IconCheckmarkCircle from '../icons/icon_checkmark_circle';
import IconFunnelClear from '../icons/icon_funnel_clear';
import IconSlashCircle from '../icons/icon_slash_circle';
import useTableContext from '../table/use_table_context';
import ColumnOptions from './column_options';
import styles from './use_styles';
import { jsx as ___EmotionJSX } from "@emotion/core";
var TableHeader = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var {
    component: Component = 'div'
  } = _ref;
  var {
    actionArea,
    columnReorder,
    controlArea,
    data,
    i18n,
    numberOfSelectedItems,
    onClearAllFilters,
    onDeselectAllItems,
    onSelectAllItems,
    pagination,
    rowSelector,
    showClearAllFilters,
    showFilters,
    theme
  } = useTableContext();
  var shouldRenderNumberOfSelectedItems = rowSelector && numberOfSelectedItems != undefined;
  var shouldRenderClearAllFilters = showFilters && showClearAllFilters;
  var style = styles({
    theme
  });
  var selectedItems = React.useMemo(() => {
    var selectedItemsVisible = numberOfSelectedItems !== undefined && numberOfSelectedItems > 0;
    if (!selectedItemsVisible) {
      return;
    }
    var selectedItemsLabelToReplace = numberOfSelectedItems > 1 ? i18n.itemsSelected : i18n.itemSelected;
    var selectedItemsLabel = selectedItemsLabelToReplace.replace(/(%s)/g, numberOfSelectedItems.toString());
    return ___EmotionJSX("span", {
      "aria-live": "polite",
      css: style.itemsSelected,
      role: "region"
    }, selectedItemsLabel);
  }, [numberOfSelectedItems, i18n, style.itemsSelected]);
  var showSelectAll = false;
  var showDeselectAll = undefined;
  var selectAllLabel = '';
  if (pagination) {
    var {
      pageSize,
      totalItems
    } = pagination;
    var multiPages = pageSize !== undefined && totalItems > pageSize;
    var isDataAllSelected = totalItems === numberOfSelectedItems;
    if (onSelectAllItems && multiPages) {
      showSelectAll = !isDataAllSelected && data.filter(row => row.rowConfig ? row.rowConfig.selected : false).length === data.length;
    }
    showDeselectAll = onDeselectAllItems && multiPages && isDataAllSelected;
    selectAllLabel = i18n.selectAllItems.replace('%{totalNumberOfItems}', totalItems.toString());
  }
  var handleClearClick = React.useCallback(event => {
    onClearAllFilters === null || onClearAllFilters === void 0 || onClearAllFilters(event, true);
  }, [onClearAllFilters]);
  var hasHeaderElement = actionArea || columnReorder || controlArea || shouldRenderClearAllFilters || shouldRenderNumberOfSelectedItems;
  if (!hasHeaderElement) return null;
  return ___EmotionJSX(Component, {
    css: style.root,
    ref: ref
  }, ___EmotionJSX("div", {
    css: style.actionArea
  }, actionArea), showFilters && showClearAllFilters && ___EmotionJSX(Button, {
    appearance: "ghost",
    "aria-label": i18n.clearAllFilters,
    leadingIcon: ___EmotionJSX(IconFunnelClear, null),
    name: "button",
    onClick: handleClearClick
  }, i18n.clearAllFilters), showSelectAll && ___EmotionJSX(Button, {
    appearance: "ghost",
    leadingIcon: ___EmotionJSX(IconCheckmarkCircle, null),
    name: "button",
    onClick: onSelectAllItems
  }, selectAllLabel), showDeselectAll && ___EmotionJSX(Button, {
    appearance: "ghost",
    leadingIcon: ___EmotionJSX(IconSlashCircle, null),
    name: "button",
    onClick: onDeselectAllItems
  }, i18n.deselectAllItems), selectedItems, columnReorder && ___EmotionJSX(ColumnOptions, null), controlArea && ___EmotionJSX("div", {
    css: style.controlArea
  }, controlArea));
});
TableHeader.displayName = 'TableHeader';
export default TableHeader;